// import React, {
//   Fragment,
//   useContext,
//   useEffect,
//   useRef,
//   useState,
// } from "react";
// import { bottomNavigation } from "../constraints/constants";
// import { Link, useLocation } from "react-router-dom";
// import MyBets from "./MyBets";
// import BetSlipContext from "../context/BetSlipContext";
// import { useNavigate } from "react-router-dom";
// import { isEmpty } from "lodash";
// import AuthContext from "../context/AuthContext";
// import { motion } from "framer-motion";
// const BottomNavigation = () => {
//   let location = useLocation();
//   const navigate = useNavigate();
//   const { user } = useContext(AuthContext);
//   const { showBet, setShowBet } = useContext(BetSlipContext);

//   return (
//     <>
//       <div className="bottom-navigation">
//         <ul className="p-sm-3 p-2 m-0 py-sm-2">
//           {bottomNavigation?.map((item, index) => {
//             return (
//               <li
//                 style={{
//                   position: "relative",
//                 }}
//                 onClick={() => {
//                   if (item?.id == 5) {
//                     if (!isEmpty(user)) {
//                       setShowBet(true);
//                     } else {
//                       navigate("/login");
//                     }
//                   } else {
//                     navigate(item?.link);
//                   }
//                 }}
//               >
//                 <span
//                   style={{
//                     position: "relative",
//                     zIndex: "10",
//                   }}
//                 >
//                   <div className="position-relative">
//                     <img src={item?.icon} alt="" />
//                   </div>
//                   <span style={{ fontSize: ".7857142857142857rem" }}>
//                     {item?.menu}
//                   </span>
//                 </span>
//                 {location.pathname === item?.link && (
//                   <motion.span
//                     layoutId="pill-tab"
//                     transition={{ type: "spring", duration: 0.5 }}
//                     style={{
//                       position: "absolute",
//                       inset: "0px",
//                       zIndex: "0",
//                       background: "#ffc800",
//                       color: "black",
//                       fontSize: "9px",
//                       borderRadius: "10px",
//                       padding: "2px 15px",
//                     }}
//                   ></motion.span>
//                 )}
//               </li>
//             );
//           })}
//         </ul>
//       </div>
//       {showBet && <MyBets setShowBet={setShowBet} />}
//     </>
//   );
// };

// export default BottomNavigation;

import React, {
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import { bottomNavigation } from "../constraints/constants";
import { useLocation, useNavigate } from "react-router-dom";
import MyBets from "./MyBets";
import BetSlipContext from "../context/BetSlipContext";
import { isEmpty } from "lodash";
import AuthContext from "../context/AuthContext";
import { motion } from "framer-motion";

let lastRect = null;

const getId = (item, index) => item?.id ?? index;

const isActivePath = (pathname, link) =>
  !!link &&
  (pathname === link || (link !== "/" && pathname.startsWith(link + "/")));

const findActiveId = (pathname) => {
  const index = (bottomNavigation || []).findIndex(
    (item) => item?.id != 5 && isActivePath(pathname, item?.link),
  );
  return index === -1 ? null : getId(bottomNavigation[index], index);
};

const BottomNavigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const { showBet, setShowBet } = useContext(BetSlipContext);

  const activeId = findActiveId(location.pathname);
  const [rect, setRect] = useState(null);
  const startRect = useRef(lastRect).current; 
  const itemRefs = useRef({});

  const measure = () => {
    const el = itemRefs.current[activeId];
    if (activeId == null || !el) {
      lastRect = null;
      setRect(null);
      return;
    }
    const next = {
      x: el.offsetLeft,
      y: el.offsetTop,
      width: el.offsetWidth,
      height: el.offsetHeight,
    };
    lastRect = next;
    setRect(next);
  };

  useLayoutEffect(measure, [activeId]);

  useEffect(() => {
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, [activeId]);

  const handleClick = (item) => {
    if (item?.id == 5) {
      if (!isEmpty(user)) {
        setShowBet(true);
      } else {
        navigate("/login");
      }
      return;
    }
    navigate(item?.link);
  };

  return (
    <>
      <div className="bottom-navigation">
        <ul className="p-sm-3 p-2 m-0 py-sm-2" style={{ position: "relative" }}>
          {rect && (
            <motion.span
              initial={startRect ? { ...startRect } : false}
              animate={rect}
              transition={{ type: "spring", stiffness: 500, damping: 40 }}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 0,
                background: "#ffc800",
                borderRadius: "10px",
                pointerEvents: "none",
              }}
            />
          )}

          {bottomNavigation?.map((item, index) => (
            <li
              key={getId(item, index)}
              ref={(el) => (itemRefs.current[getId(item, index)] = el)}
              style={{ position: "relative" }}
              onClick={() => handleClick(item)}
            >
              <span style={{ position: "relative", zIndex: "10" }}>
                <div className="position-relative">
                  <img src={item?.icon} alt="" />
                </div>
                <span style={{ fontSize: ".7857142857142857rem" }}>
                  {item?.menu}
                </span>
              </span>
            </li>
          ))}
        </ul>
      </div>
      {showBet && <MyBets setShowBet={setShowBet} />}
    </>
  );
};

export default BottomNavigation;
